import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewerPerformanceSummaryV1Query } from './get-reviewer-performance-summary-v1-request';
import type { IGetReviewerPerformanceSummaryV1Response } from './get-reviewer-performance-summary-v1-response';
import { getReviewerPerformanceSummaryV1ResponseSchema } from './get-reviewer-performance-summary-v1-response';

export async function getReviewerPerformanceSummaryV1Api(
  query: IGetReviewerPerformanceSummaryV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReviewerPerformanceSummaryV1Response>> {
  const params = new URLSearchParams();
  if (query.days != null) {
    params.set('days', String(query.days));
  }
  const qs = params.toString();
  return getRequest<IGetReviewerPerformanceSummaryV1Response>({
    path: `/sys/reviewer-performance/v1/summary${qs ? `?${qs}` : ''}`,
    schema: getReviewerPerformanceSummaryV1ResponseSchema,
    options,
  });
}
